const API_URL = process.env.REACT_APP_BACKEND_URL;

export default API_URL;

export const isProdEnv = process.env.REACT_APP_IS_PROD_ENV;
export const secretEncryptionKey = process.env.REACT_APP_SECRET_ENCRYPTION_KEY;
